import * as React from 'react';
import './App-Admin.css';
import { RuwacWidget } from '../../core/RuwacWidget';
import { Menu } from '../Menu/Menu';
import { IUserAgentType, ICanvasSize } from '../../sharedInterfaces';
import {ModelControler} from "../../service/modelController";
import {Startup} from "../Startup/Startup";
import {PriceService} from "../../service/PriceService";
import {Checkout} from "../../service/Checkout";
import { AnimationMixer, LoopRepeat } from 'three';
const axios = require("axios");

interface AppProps {
  rootDiv:HTMLElement,
  assetPath:string,
}

interface AppState {
  widget:RuwacWidget,
  userAgentType:IUserAgentType,
  canvasSize:ICanvasSize,
  preserveCamera:boolean,
  autoScaleUp:boolean,
  autoScaleDown:boolean,
  startMenuOn:boolean
}

class AppAdmin extends React.Component<AppProps, AppState> {
  constructor(props:AppProps) {
    super(props);
    this.state = {
      widget: new RuwacWidget(ModelControler.instance.getCurrentProductPath(), this.getAssetPathFromRootDivData()),
      userAgentType: IUserAgentType.desktop,
      canvasSize: {
        w: window.innerWidth,
        h: window.innerHeight
      },
      preserveCamera: false,
      autoScaleUp: false,
      autoScaleDown: true,
      startMenuOn:true
    }
  }

  componentDidMount() {
    this.state.widget.initialize(document.getElementById("vc-3d-app") as HTMLDivElement)
    .then(() => {
        this.initProduct()
    });

    //FIXME: re-enable once mobile menu is done
    //this.getUserAgentType();

    //event listeners
      this.getTokenFromQueryString();
      window.addEventListener("resize", () => {
       this.getUserAgentType();
      })

  }

  getTokenFromQueryString = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      // console.log("Token", token)
      if(token){
          Checkout.instance.seCSRFToken(token);
      }
  }

  getUserAgentType() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    //Default
    let userAgentType = IUserAgentType.desktop;

    //FIXME: re-enable once mobile menu exists!
    //Conditional changes
    // if (height > width) {
    //   userAgentType = IUserAgentType.mobile;
    // }

    this.setState({
      userAgentType: userAgentType,
    })
  }

  // Remove again for server side Assets
  getAssetPathFromRootDivData() {
    //"http://127.0.0.1:5500/Assets/"
    return this.props.rootDiv.dataset.assetpath || "Assets/";
  }

  changeCanvasSize = (w:number, h:number):void => {
    this.setState({
      canvasSize: {
        w: w,
        h: h
      }
    }, () => {
      // console.log("this.state.canvasSize.w = ", this.state.canvasSize.w, "this.state.canvasSize.h = ", this.state.canvasSize.h, "this.state.canvasSize = ", this.state.canvasSize);

      let appContainer:HTMLDivElement = document.querySelector("#vc-3d-app");

      if (this.state.canvasSize.w < window.innerWidth) {
        appContainer.style.width = this.state.canvasSize.w + "px";
        appContainer.style.borderRight = "1px solid black";
        appContainer.style.borderLeft = "1px solid black";
      } else {
        appContainer.style.width = "100%";
        appContainer.style.borderRight = "none";
        appContainer.style.borderLeft = "none";
      }

      if (this.state.canvasSize.h < window.innerHeight) {
        appContainer.style.height = this.state.canvasSize.h + "px";
        appContainer.style.borderTop = "1px solid black";
        appContainer.style.borderBottom = "1px solid black";
      } else {
        appContainer.style.height = "100%";
        appContainer.style.borderTop = "none";
        appContainer.style.borderBottom = "none";
      }

      //simulate window resize to make threngine resize renderer
      window.dispatchEvent(new Event('resize'));

      this.state.widget.scaleObjectToCanvas(this.state.autoScaleUp, this.state.autoScaleDown);
    })
  }

  initProduct = ():Promise<void> => {
    const overwriteDefault:any = {};
    if (this.state.preserveCamera) {
      overwriteDefault.cameras = [];
      overwriteDefault.cameras.push(this.state.widget.getCurrentCamera());
      }
      return new Promise((resolve) => {
        this.state.widget.loadProduct(overwriteDefault)
            .then(() => {
              // console.log("finish load product")
              this.setMeshVisibility();
              PriceService.instance.getAllProductPrice();
              resolve();
            })
      });
  }

  onProductChange = ():Promise<void> => {
    // console.log("SWITCH PRODUCT TO " + ModelControler.instance.getCurrentProductPath());
    const overwriteDefault:any = {};

    if (this.state.preserveCamera) {
      overwriteDefault.cameras = [];
      overwriteDefault.cameras.push(this.state.widget.getCurrentCamera());
    }

    return new Promise((resolve) => {
      this.state.widget.setBlueprintPath(ModelControler.instance.getCurrentProductPath())
          .then(()=>{
              this.state.widget.loadProduct(overwriteDefault)
                  .then(() => {
                      this.setMeshVisibility();
                      PriceService.instance.getAllProductPrice()
                          .then(()=>{
                            resolve();
                          })
                  })
          })
    });
  }



  setMeshVisibility(){
      this.state.widget.getAllMeshGroup()
          .then((result)=>{
              ModelControler.instance.getFeatures().forEach(
                  (feature)=>{
                    feature.getModelList().forEach(
                        (model)=> {
                          const group = result.find(e => e.name === model.name)
                          group.visible = model.visibility;
                        }
                    )
                  }
              )
          })
  }

  playAnimation(name:string){
    if (true) {
      this.state.widget.playAnimation(name);
    }
  }

  setCamema(name:string){
    this.state.widget.setCamera(name);
  }

  turnOnStartMenu(){
    this.setState({
      startMenuOn: true
    })
  }

  turnOffStartMenu(){
    this.setState({
      startMenuOn: false
    })
  }

  render() {
      return (
        <div style={{height: "100%", position: "relative", width: "100%"}}>
            <Startup onChangeProduct={this.onProductChange.bind(this)} startMenuOn={this.state.startMenuOn} closeStartMenu={this.turnOffStartMenu.bind(this)}/>
            <div id="vc-3d-app"></div>
            <Menu
              userAgentType = {this.state.userAgentType}
              canvasSize = {this.state.canvasSize}
              preserveCamera = {this.state.preserveCamera}
              autoScaleUp = {this.state.autoScaleUp}
              autoScaleDown = {this.state.autoScaleDown}
              setMeshVisibility={this.setMeshVisibility.bind(this)}
              setCamera = {this.setCamema.bind(this)}
              playAnimation = {this.playAnimation.bind(this)}
              //changeProductWrapper = {this.changeProductWrapper}
              changeCanvasSize = {this.changeCanvasSize}
              goBack = {this.turnOnStartMenu.bind(this)}
              startMenuOn = {this.state.startMenuOn}
            />
        </div>
      )
  }
}

export default AppAdmin;